import React, {memo, useState} from 'react'
import handwai_logo from "../Design/logo.png"; // gives image path
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {resetPwd, sendEmail} from '../API/user';

const logoStyle = {
    marginLeft: 20
};

const btnStyle = {
    backgroundColor: 'var(--handwai-orange-color)',
    borderColor: 'var(--handwai-orange-color)',
    color: 'var(--handwai-grey-1-color)',
    borderRadius: 0
};


function ForgotPassword() {
    const [em, setUserName] = useState();
    localStorage.clear();

    const handleClick = async e => {
        e.preventDefault();
        const rsl = await resetPwd({em});
        if (rsl.status === 200) {
            let emaildetails = {
                emailtype: "passwordreset",
                emaildetails: {
                    username: rsl.username,
                    email: rsl.useremail,
                    otp: rsl.otp
                }
            }
            await sendEmail(emaildetails)
            alert('Bitte prüfe dein Postfach');
        } else {
            alert('Ihr Account ist deaktiviert.');
        }
        //window.location.href = process.env.REACT_APP_FRONTEND_PATH_LANDINGPAGE;
        window.location.href = process.env.REACT_APP_FRONTEND_PATH_LOGIN
    };

    return (
        <div>
            <br/>
            <header><img
                alt="Handwai GmbH Company Logo"
                src={handwai_logo}
                width="300"
                height="75"
                style={logoStyle}
            /></header>
            <br/><br/>

            <Row>
                <Col/>
                <Col>

                    <div className="container handwai-dark handwai-text-label-normal">

                        <Form>
                            <br/><br/>
                            <Container className="handwai-text-label-main">
                                <Row>

                                    <Col className="justify-content-center text-center">Passwort vergessen</Col>
                                </Row>
                            </Container>

                            <br/><br/>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Label/>
                                <Form.Control type="email" className="handwai-input" placeholder="Email Adresse"
                                              onChange={event => setUserName(event.target.value)}/>
                            </Form.Group>
                            <br/>

                            <br/>
                            <Row>
                                <Col className=" d-flex justify-content-center"><Button className="handwai-btn-login"
                                                                                        style={btnStyle}
                                                                                        onClick={handleClick}
                                                                                        size="lg" block>

                                    PASSWORT ZÜRUCKSETZEN </Button></Col>

                            </Row>

                            <br/> <br/>
                        </Form>
                    </div>
                </Col>
                <Col/>
            </Row>
        </div>
    );
}

export default memo(ForgotPassword);